// Shared between the history table (LeadEngine.jsx) and the in-progress
// elapsed-time indicator (Startworlflow.jsx) so both format durations the
// same way instead of drifting apart.

// Formats a duration given in seconds as "32s" under a minute, or "1:05"
// (m:ss) at or above a minute. Real full-pipeline runs measured via n8n's
// own execution history land around 30-45s, so most values here will be
// plain seconds - minutes only show up if a stage runs unusually slow.
export function formatDuration(seconds) {
  if (seconds == null || Number.isNaN(seconds) || seconds < 0) return "—";
  const total = Math.round(seconds);
  if (total < 60) return `${total}s`;
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  return `${minutes}:${String(secs).padStart(2, "0")}`;
}

// created_at/updated_at are ISO timestamp strings from the backend.
export function durationBetween(startIso, endIso) {
  if (!startIso || !endIso) return null;
  const seconds = (new Date(endIso).getTime() - new Date(startIso).getTime()) / 1000;
  return Number.isNaN(seconds) ? null : seconds;
}
